import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="why-choose-us-new">
      <div className="container">
        <div className="section-header-new">
          <h2>Why Choose CodeAlignR?</h2>
          <p>We focus on delivering practical AI solutions that solve real business problems</p>
        </div>
        <div className="features-grid-new">
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-rocket"></i>
            </div>
            <h3>Quick Setup</h3>
            <p>Get your AI agents working in days, not months. We handle the setup and integration.</p>
          </div>
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-dollar-sign"></i>
            </div>
            <h3>Cost Effective</h3>
            <p>Save thousands on staffing costs while providing better customer service.</p>
          </div>
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-clock"></i>
            </div>
            <h3>24/7 Availability</h3>
            <p>Your AI agents never sleep, never take breaks, and never get sick.</p>
          </div>
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3>Proven Results</h3>
            <p>See measurable improvements in customer satisfaction and operational efficiency.</p>
          </div>
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-cog"></i>
            </div>
            <h3>Customizable</h3>
            <p>Tailored to your business needs, brand voice, and specific requirements.</p>
          </div>
          <div className="feature-new">
            <div className="feature-icon-new">
              <i className="fas fa-headset"></i>
            </div>
            <h3>Human Backup</h3>
            <p>Seamless handoff to human agents when complex issues arise.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
